import script from "./BrandIconButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandIconButton.vue?vue&type=script&setup=true&lang=ts"

import "./BrandIconButton.vue?vue&type=style&index=0&id=57cac654&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57cac654"]])

export default __exports__